import * as React from "react";
import "./styles/Kontakt.css";

export const Kontakt: React.FC = () => {
  return (
    <>
      <section className="page-header-kontakt"></section>

      <section className="contact-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="section-heading-wrapper text-center">
                <div className="section-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <h2 className="section-heading-inline">Povežite se sa nama</h2>
                <p className="section-subtitle">
                  Imate pitanja o našim emisijama ili predlog za saradnju?
                  Budemo srećni da čujemo od vas.
                </p>
              </div>
              <div className="contact-card">
                <div className="contact-info-container">
                  <div className="contact-info-box">
                    <ul className="contact-info">
                      <li>
                        <span className="icon-container">
                          <i className="fa fa-home"></i>
                        </span>
                        <address>Podgorica</address>
                      </li>
                      <li>
                        <span className="icon-container">
                          <i className="fa fa-phone"></i>
                        </span>
                        <address>
                          <a href="tel:+38268898512">+382 68 898 512</a>
                        </address>
                      </li>
                      <li>
                        <span className="icon-container">
                          <i className="fa fa-phone"></i>
                        </span>
                        <address>
                          <a href="tel:+38267099997">+382 67 099 997</a>
                        </address>
                      </li>
                    </ul>
                  </div>

                  <div className="contact-info-box">
                    <ul className="contact-info">
                      <li>
                        <span className="icon-container">
                          <i className="fa fa-envelope"></i>
                        </span>
                        <address>
                          <a href="mailto:creativehubmne@gmail.com">
                            creativehubmne@gmail.com
                          </a>
                        </address>
                      </li>
                      <li>
                        <span className="icon-container">
                          <i className="fa fa-globe"></i>
                        </span>
                        <address>
                          <a
                            href="https://www.creativehubmne.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            www.creativehubmne.com
                          </a>
                        </address>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="social-section">
                  <h2 className="contact-title">Društvene mreže</h2>
                  <p
                    style={{
                      color: "#666",
                      marginBottom: "25px",
                      fontSize: "1.1rem",
                      maxWidth: "600px",
                      margin: "0 auto 30px",
                    }}
                  >
                    Budite u toku sa najnovijim vijestima i događajima.
                    Zapratite nas na društvenim mrežama!
                  </p>
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/profile.php?id=100094573102351&mibextid=ViGcVu"
                      className="btn-social-icon facebook"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Pratite nas na Facebook-u"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://x.com/djedovina?t=WsOH3Nu6OQShkelHzoBoYA&s=09"
                      className="btn-social-icon twitter"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Pratite nas na X-u"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a
                      href="https://www.youtube.com/@creativehubmne"
                      className="btn-social-icon youtube"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Pratite nas na YouTube-u"
                    >
                      <i className="fab fa-youtube"></i>
                    </a>
                    <a
                      href="https://instagram.com/djedovinacg?igshid=OTBlMGdoamE5YWZx"
                      className="btn-social-icon instagram"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Pratite nas na Instagram-u"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@djedovina?_t=8hCK6LV8heP&_r=1"
                      className="btn-social-icon tiktok"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Pratite nas na TikTok-u"
                    >
                      <i className="fab fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
